import imageCompression from "browser-image-compression";

type CompressImagePreset = "xs" | "sm" | "md" | "lg" | "xl";

type CompressImageOptions =
  | { preset: CompressImagePreset }
  | { maxSizeMB: number; maxWidthOrHeight: number };

type ResolvedOptions = { maxSizeMB: number; maxWidthOrHeight: number };

const PRESETS: Record<CompressImagePreset, ResolvedOptions> = {
  xs: { maxWidthOrHeight: 200,  maxSizeMB: 0.1 },
  sm: { maxWidthOrHeight: 400,  maxSizeMB: 0.3 },
  md: { maxWidthOrHeight: 1280, maxSizeMB: 1   },
  lg: { maxWidthOrHeight: 1920, maxSizeMB: 2   },
  xl: { maxWidthOrHeight: 2560, maxSizeMB: 4   },
};

const resolveOptions = (options?: CompressImageOptions): ResolvedOptions => {
  if (!options) return PRESETS.lg;
  if ("preset" in options) return PRESETS[options.preset];
  return options;
};

export const compressImage = async (
  file: File,
  options?: CompressImageOptions,
): Promise<File> => {
  const { maxSizeMB, maxWidthOrHeight } = resolveOptions(options);
  const thresholdBytes = maxSizeMB * 1024 * 1024;

  if (file.size <= thresholdBytes) return file;

  try {
    const compressed = await imageCompression(file, {
      maxSizeMB,
      maxWidthOrHeight,
      useWebWorker: true,
      preserveExif: false,
    });

    console.debug(
      `Compressed image from ${(file.size / (1024 * 1024)).toFixed(2)} mb to ${(compressed.size / (1024 * 1024)).toFixed(2)} mb`,
    );

    return new File([compressed], file.name, { type: compressed.type });
  } catch {
    return file;
  }
};
